<template>
	<div style="width:900px; height:710px;" v-on:keyup.esc="close()">
		<div class="view_inner">
			<div class="fixed-table-container" style="height:630px;">
				<div class="table-wrapper">
					<table id="item_list" class="list_tbl">
						<thead>
							<tr>
								<th style="text-align:center;width:100px;"><div class="th-text">S/O No</div></th>
								<th style="text-align:center;width:90px;"><div class="th-text">S/O Date</div></th>
								<th style="text-align:center;width:100px;"><div class="th-text">Status</div></th>
								<th style="text-align:center;width:80px;"><div class="th-text ">Ship To</div></th>
								<th style="text-align:center;"><div class="th-text ">Name</div></th>
								<th style="text-align:center;width:130px;"><div class="th-text ">Sales Group</div></th>
								<th style="text-align:center;width:70px;"><div class="th-text ">Territory</div></th>
								<th style="text-align:center;width:60px;"><div class="th-text">Qty</div></th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="invoice in invoices" v-bind:key="invoice.invoice_no">
								<td>
									<a href="javascript:;" @click="selectSo(invoice)">{{ invoice.so_dn }}</a>
								</td>
								<td>{{ invoice.so_date }}</td>
								<td class="al_center">{{ invoice.status_code | saleStatusName }}</td>
								<td class="al_left">{{ invoice.ship_to_code }}</td>
								<td class="al_left truncate">{{ invoice.ship_to_name }}</td>
								<td class="al_left truncate">{{ invoice.sales_group_name }}</td>
								<td class="al_left truncate">{{ invoice.territory_name }}</td>
								<td class="al_right">{{ invoice.quantity | commaSeparated }}</td>
							</tr>
							<tr>
								<td class="al_right" colspan="7">Total</td>
								<td class="al_right">{{ total_quantity | commaSeparated }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<br />

			<div class="view_bottom_bt">
				<a href="javascript:;" id="save" type="button" class="gray_bt" @click="close()">Close</a>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/table_box.css';
import { apiSelectPreemptedInvoiceList } from '@/api/sales/invoice.js';

export default {
	data: function() {
		return {
			invoices: [],
		};
	},
	props: {
		invoice_no: Number,
		item_id: String,
		pending_90: Boolean,
	},
	computed: {
		total_quantity() {
			var total = 0;
			this.invoices.forEach(i => {
				total += i.quantity;
			});

			return total;
		},
	},
	components: {},
	methods: {
		selectSo(invoice) {
			let routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
			window.open(routeData.href, 'herp_so');
		},
		async selectPreemptedList() {
			let param = {
				invoice_no: this.invoice_no,
				item_id: this.item_id,
			};

			if (this.pending_90) param.pending_90 = true;
			const { data } = await apiSelectPreemptedInvoiceList(param);

			this.invoices = data.invoiceList;
			//console.log(this.invoices);
		},

		async init() {
			await this.selectPreemptedList();
		},

		close() {
			this.$emit('close');
		},
	},
	created() {
		this.init();
	},
};
</script>

<style></style>
